/* eslint-disable no-unused-vars */
import { memo, useCallback } from 'react';
import * as S from './MenuItem.styled';
import PropTypes from 'prop-types';

export const MenuItem = memo(
  ({
    value,
    icon,
    children,
    id,
    width,
    height,
    onClick,
    disabled,
    isSelected,
    isDestructive,
    wrapStyle,
    style,
    as,
    to,
  }) => {
    const IconToShow = useCallback(() => {
      if (typeof icon === 'function') return icon();
      else if (typeof icon === 'object') return icon;
    }, [icon]);

    return (
      <S.ItemContainer
        value={value}
        id={id}
        width={width}
        height={height}
        onClick={() => onClick(value)}
        disabled={disabled}
        isSelected={isSelected}
        isDestructive={isDestructive}
        style={style}
      >
        <S.InnerBox as={as} to={to}>
          {icon && (
            <S.IconWrap>
              <IconToShow />
            </S.IconWrap>
          )}
          <div style={wrapStyle}>{children}</div>
        </S.InnerBox>
      </S.ItemContainer>
    );
  },
);

MenuItem.displayName = 'MenuItem';
MenuItem.prototype = {
  icon: PropTypes.func,
};
